import { Box, Flex, Text, VStack } from '@chakra-ui/react'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import React from 'react'

interface SessionExchangeProps {
  currentPlan: string
  currentSessions: number
  currentFreeCredits: number
  newPlan: string
  convertedSessions: number
  convertedFreeCredits: number
}

export const SessionExchange = ({
  currentPlan,
  currentSessions,
  currentFreeCredits,
  newPlan,
  convertedSessions,
  convertedFreeCredits
}: SessionExchangeProps) => {
  // Determine if user is upgrading or downgrading
  const isUpgrading =
    currentPlan.toLowerCase() === 'standard' && newPlan.toLowerCase() === 'plus'
  const isDowngrading =
    currentPlan.toLowerCase() === 'plus' && newPlan.toLowerCase() === 'standard'

  // Dynamic text based on upgrade/downgrade scenario
  const getExchangeText = () => {
    if (isUpgrading) {
      return `We convert your existing sessions based on plan value ratios. Since Plus sessions are more valuable than Standard sessions, you'll receive fewer sessions but with enhanced features. We always round up in your favor.`
    } else if (isDowngrading) {
      return `We convert your existing sessions based on plan value ratios. Since Plus sessions are more valuable than Standard sessions, you'll receive more sessions but with reduced features. We always round up in your favor.`
    } else {
      // Fallback for any other scenario
      return `We convert your existing sessions based on plan value ratios. We've calculated the equivalent value for your new plan below.`
    }
  }

  return (
    <Box p="medium" bg="gray.50" borderRadius="lg">
      <Text fontSize="16px" fontWeight="600" color="gray.900" mb="2">
        Session Exchange
      </Text>

      <Flex align="center" justify="center" gap="10" mb="4">
        <VStack spacing="2px">
          <Text fontSize="24px" fontWeight="bold" color="gray.900">
            {currentSessions + currentFreeCredits}
          </Text>
          <Text fontSize="14px" color="gray.600">
            {currentPlan} Sessions
          </Text>
        </VStack>

        <ArrowForwardIcon style={{ color: '#6B7280' }} />

        <VStack spacing="2px">
          <Text fontSize="24px" fontWeight="bold" color="gray.900">
            {convertedSessions + convertedFreeCredits}
          </Text>
          <Text fontSize="14px" color="gray.600">
            {newPlan} Sessions
          </Text>
        </VStack>
      </Flex>

      <Box>
        <Text fontSize="14px" fontWeight="600" color="gray.900" mb="2px">
          How session exchange works:
        </Text>
        <Text fontSize="14px" color="gray.600">
          {getExchangeText()}
        </Text>
      </Box>
    </Box>
  )
}
